export default "__VITE_ASSET__CVl8qVIU__"